import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IAddressV2, IAddressV2ControlContext } from '@jump-tech-frontend/domain';
import { FormUpdate, TextboxComponent } from '@jump-tech-frontend/question-components';
import { AsyncPipe } from '@angular/common';
import { JuiButton } from '@jump-tech-frontend/core-components-angular';
import { BehaviorSubject } from 'rxjs';
import { AddressEditorViewModel } from './address-editor.vm';
import { AddressEditorPresenter } from './address-editor.presenter';

@Component({
  selector: 'jump-tech-frontend-address-editor',
  templateUrl: './address-editor.component.html',
  imports: [JuiButton, ReactiveFormsModule, TextboxComponent, AsyncPipe],
  providers: [AddressEditorPresenter],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['address-editor.component.scss']
})
export class AddressEditorComponent implements OnChanges {
  @Input() countryCodes: string[];
  @Input() selectedAddress?: IAddressV2 | null;
  @Input() context: IAddressV2ControlContext | string = IAddressV2ControlContext.Desktop;
  @Output() addressUpdated = new EventEmitter<IAddressV2 | null>();

  private readonly addressEditorPresenter = inject(AddressEditorPresenter);
  public vm$ = new BehaviorSubject<AddressEditorViewModel | null>(null);

  ngOnChanges(changes: SimpleChanges): void {
    const addressChange = changes?.['selectedAddress'];
    if (addressChange) {
      this.addressEditorPresenter.load(this.vm$, this.countryCodes, this.selectedAddress);
    }
  }

  fieldChanged($event: FormUpdate) {
    this.addressEditorPresenter.fieldChanged(this.vm$ as BehaviorSubject<AddressEditorViewModel>, $event);
  }

  protected readonly ControlContext = IAddressV2ControlContext;
}
